import React, { useState, useEffect } from "react";
import { agentApi } from "../../services/agentApi";

const DAYS = [
  { key: "mon", label: "Seg" }, { key: "tue", label: "Ter" }, { key: "wed", label: "Qua" },
  { key: "thu", label: "Qui" }, { key: "fri", label: "Sex" }, { key: "sat", label: "Sáb" },
  { key: "sun", label: "Dom" },
];

export default function PlaybookHoursEditor({ playbook, readOnly = false }) {
  const [bh, setBh] = useState(playbook.businessHours || {
    timezone: "America/Sao_Paulo",
    windows: { mon: [], tue: [], wed: [], thu: [], fri: [], sat: [], sun: [] },
  });

  useEffect(() => {
    setBh(playbook.businessHours || { timezone: "America/Sao_Paulo", windows: {} });
  }, [playbook.id]);

  function toggleDay(day) {
    const w = { ...bh.windows };
    if ((w[day] || []).length > 0) w[day] = [];
    else w[day] = [["09:00", "12:00"], ["13:00", "18:00"]];
    setBh({ ...bh, windows: w });
  }

  function updateRange(day, idx, pos, val) {
    const w = { ...bh.windows };
    const ranges = [...(w[day] || [])];
    const r = [...ranges[idx]];
    r[pos] = val;
    ranges[idx] = r;
    w[day] = ranges;
    setBh({ ...bh, windows: w });
  }

  function addRange(day) {
    const w = { ...bh.windows };
    w[day] = [...(w[day] || []), ["09:00", "18:00"]];
    setBh({ ...bh, windows: w });
  }

  function removeRange(day, idx) {
    const w = { ...bh.windows };
    w[day] = (w[day] || []).filter((_, i) => i !== idx);
    setBh({ ...bh, windows: w });
  }

  async function save() {
    try {
      await agentApi.playbooks.patch(playbook.id, { businessHours: bh });
      alert("Salvo!");
    } catch (err) {
      alert(`Erro: ${err.message}`);
    }
  }

  return (
    <div className="space-y-4 max-w-3xl">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Timezone</label>
        <input
          type="text"
          value={bh.timezone}
          onChange={(e) => setBh({ ...bh, timezone: e.target.value })}
          readOnly={readOnly}
          className={`px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-md text-sm focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
        />
      </div>
      <div className="space-y-2">
        {DAYS.map(({ key, label }) => {
          const ranges = bh.windows?.[key] || [];
          const active = ranges.length > 0;
          return (
            <div
              key={key}
              className={`flex items-start gap-3 p-3 rounded-md border transition-colors ${
                active ? "bg-blue-50 border-blue-200" : "bg-white border-gray-200"
              }`}
            >
              <label className={`flex items-center gap-2 w-24 text-gray-700 font-medium text-sm ${readOnly ? "" : "cursor-pointer"}`}>
                <input
                  type="checkbox"
                  checked={active}
                  onChange={() => toggleDay(key)}
                  disabled={readOnly}
                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:cursor-default"
                />
                {label}
              </label>
              <div className="flex-1 space-y-1">
                {active && ranges.map((r, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <input
                      type="time"
                      value={r[0]}
                      onChange={(e) => updateRange(key, i, 0, e.target.value)}
                      readOnly={readOnly}
                      className={`px-2 py-1 bg-white border border-gray-300 text-gray-900 rounded text-sm focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
                    />
                    <span className="text-gray-400 text-sm">—</span>
                    <input
                      type="time"
                      value={r[1]}
                      onChange={(e) => updateRange(key, i, 1, e.target.value)}
                      readOnly={readOnly}
                      className={`px-2 py-1 bg-white border border-gray-300 text-gray-900 rounded text-sm focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
                    />
                    {!readOnly && (
                    <button
                      type="button"
                      onClick={() => removeRange(key, i)}
                      className="text-red-400 hover:text-red-600 text-xs px-1"
                    >
                      ×
                    </button>
                    )}
                  </div>
                ))}
                {active && !readOnly && (
                  <button
                    type="button"
                    onClick={() => addRange(key)}
                    className="text-xs text-blue-600 hover:text-blue-700 font-medium"
                  >
                    + Adicionar janela
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {!readOnly && (
      <button
        type="button"
        onClick={save}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors"
      >
        Salvar janela horária
      </button>
      )}
    </div>
  );
}
